import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "CalendarBootstrapUtils"*/ "./lazyIndex"), { name: "CalendarBootstrapUtils" });

/**
 * Initializes accounts, calendars, and settings necessary for OWA modules
 *
 * Superset of `lazyInitializeAccountAndCalendars` that covers additional concerns not relevant
 * to event deeplinks, such as (but not limited to):
 * - conditional auto-selection of default calendar
 * - fetch of scenario settings
 * - auto-upgrade of shared calendars
 */
export const lazyInitializeCalendarsDataForModule: LazyAction<typeof lazyIndex.initializeCalendarsDataForModule, typeof lazyModule> = new LazyAction(lazyModule, m => m.initializeCalendarsDataForModule);

/**
 * Initializes just the accounts and calendars
 */
export const lazyInitializeAccountAndCalendars: LazyAction<typeof lazyIndex.initializeAccountAndCalendars, typeof lazyModule> = new LazyAction(lazyModule, m => m.initializeAccountAndCalendars);

export const lazyInitializeGroupCalendarFolderId: LazyAction<typeof lazyIndex.initializeGroupCalendarFolderId, typeof lazyModule> = new LazyAction(lazyModule, m => m.initializeGroupCalendarFolderId);
